export type ClassValue = string | false | null | undefined;

/** Minimalni spajač klasa — bez ovisnosti, bez ijedne boje u kodu. */
export function cx(...parts: ClassValue[]): string {
  return parts.filter(Boolean).join(' ');
}
